import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { ReactTitle } from "react-meta-tags";

import { DRAFT_CUSTOM_PANEL_TITLE } from "helpers/metatags";
import { CatalogDetailProvider } from "hooks/useCatalogDetail";
import { DraftCustomPanelDetail } from "./components/PanelDetail";
import { DraftCustomPanels } from "./DraftCustomPanels";
import { DraftCustomPanelProvider } from "./useDraftCustomPanel";

const DraftCustomPanelsRoute = (props: any) => {
  const { path } = useRouteMatch();

  return (
    <DraftCustomPanelProvider>
      <CatalogDetailProvider>
        <ReactTitle title={DRAFT_CUSTOM_PANEL_TITLE} />
        <Switch>
          <Route exact path={path}>
            <DraftCustomPanels {...props} />
          </Route>
          <Route exact path={`${path}/:id/view`}>
            <DraftCustomPanelDetail
              key="draft-custom-panel-detail"
              {...props}
            />
          </Route>
          <Route exact path={`${path}/:id/edit`}>
            <DraftCustomPanelDetail
              key="draft-custom-panel-customize"
              customize
              {...props}
            />
          </Route>
          <Redirect to={path} />
        </Switch>
      </CatalogDetailProvider>
    </DraftCustomPanelProvider>
  );
};

export default DraftCustomPanelsRoute;
